import { ApolloProvider } from '@apollo/client';
import React from 'react';
import  { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { client } from './gql/token';
import { BrowserRouter, HashRouter } from 'react-router-dom';


// Prevent search engines from indexing dev/stage environments (inferred from the API URL)
if (/dev|stage/i.test(process.env.REACT_APP_API_URL || '')) {
  const robotsMeta = document.createElement('meta');
  robotsMeta.name = 'robots';
  robotsMeta.content = 'noindex, nofollow';
  document.head.appendChild(robotsMeta);
}

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(
  // <React.StrictMode>
    <ApolloProvider client={client}>
      <HashRouter>
      <App />
      </HashRouter>
    </ApolloProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
